export class MemberNewsSearchResult {
    constructor(){
        this.articles = [];
    }
    totalResults: number;
    articles: DumbMemberNewsArticle[];
    latestNews: DumbMemberNewsArticle;
}
export class DumbMemberNewsArticle {
    articleId: number;
    title: string;
    dateString: string;
    contentShortened: string;
    contentFull: string;
    imageId: string;
    imageUrl: string;
    memberId: string;
    memberName: string;
    isPortrait: boolean;
}
